import { IconClose } from 'components/atoms/icons/IconClose';
import styles from './imagePreviewList.module.scss';

interface ImagePreviewListProps {
  images: Array<{ file: File; preview: string; base64: string }>;
  onImageClick: (preview: string) => void;
  onRemoveImage: (index: number) => void;
}

export const ImagePreviewList = ({
  images,
  onImageClick,
  onRemoveImage,
}: ImagePreviewListProps) => {
  if (images.length === 0) return null;

  return (
    <div className={styles.imagePreviewList}>
      {images.map(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (image: any, index: number) => (
          <div key={index} className={styles.imagePreview}>
            <img
              src={image.preview}
              alt={`Preview ${index + 1}`}
              className={styles.previewImage}
              onClick={() => onImageClick(image.preview)}
            />
            <button
              type="button"
              className={styles.removeButton}
              onClick={() => onRemoveImage(index)}
            >
              <IconClose />
            </button>
          </div>
        )
      )}
    </div>
  );
};
